import React from 'react';
import _ from 'lodash';
import { getCodesWithMessage } from 'utils/codes';
import {
  Card, Col, Statistic, Typography
} from 'antd';

const { Text } = Typography;

const renderCode = (recipeIngredients) => {
  if (_.isUndefined(recipeIngredients.ingredients)) {
    return false;
  }

  const { message, codes } = getCodesWithMessage(recipeIngredients.ingredients);
  const content = !_.isEmpty(codes) ? codes : 'Aucune codification ne correspond à cette recette';
  return (
    <Col span={12}>
      <Card>
        <Statistic
          title="Codification simulants flexible pour cette recette"
          value={content}
          precision={2}
          valueStyle={{ color: '#3f8600' }}
        />
        <Text style={{ color: 'orange' }}>{message}</Text>
      </Card>
    </Col>
  );
};

export default renderCode;
